import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import DtoSampling from '../../dto/DtoSampling'
import SimpleDatePicker from '../../../../../components/forms/SimpleDatePicker'
import Input from '../../../../../components/forms/Input'
import NumberField from '../../../../../components/forms/NumberField'
import Textarea from '../../../../../components/forms/Textarea'
import { getHour } from '../../../../../utils/DateUtil'
import { onChangeHour } from '../../../../../utils/FormUtils'

const SamplingModal = ({
    isOpen = false,
    onValidate = () => {},
    onClose = () => { },
    selectedSampling = {},
}) => {
    const [sampling, setSampling] = useState(selectedSampling)
    const change = (changes) => setSampling({ ...sampling, ...changes })
    return (
        <Dialog
            fullWidth
            maxWidth='sm'
            open={isOpen}
            onClose={() => {}}
        >
            <DialogTitle>{i18n.editSampling}</DialogTitle>
            <DialogContent>
                <Grid container spacing={1} alignItems='center'>
                    <Grid size={6}>
                        <SimpleDatePicker value={sampling.date} label={i18n.date} onChange={v => change({ date: v })} />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.hour}
                            value={getHour(sampling.date)}
                            onChange={v => onChangeHour(v, v2 => change({ date: v2 }), {}, sampling.date)}
                        />
                    </Grid>
                    <Grid size={6}>
                        <SimpleDatePicker value={sampling.arrivalDate} label={i18n.receptionDate} onChange={v => change({ arrivalDate: v })} />
                    </Grid>
                    <Grid size={6}>
                        <Input
                            title={i18n.hour}
                            value={getHour(sampling.arrivalDate)}
                            onChange={v => onChangeHour(v, v2 => change({ arrivalDate: v2 }), {}, sampling.arrivalDate)}
                        />
                    </Grid>
                    <Grid size={6}>
                        <NumberField
                            title={i18n.receptionTemperature}
                            value={sampling.receptionTemperature}
                            onChange={v => change({ receptionTemperature: v })}
                            floatValue
                        />
                    </Grid>
                    <Grid size={6} />
                    <Grid size={6}>
                        <Input value={sampling.ref} title={i18n.internalReference} onChange={v => change({ ref: v })} />
                    </Grid>
                    <Grid size={6}>
                        <Input value={sampling.refLabo} title={i18n.refLabo} onChange={v => change({ refLabo: v })} />
                    </Grid>
                    <Grid size={12}>
                        <Textarea value={sampling.comment} title={i18n.comment} onChange={v => change({ comment: v })} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant='outlined' >
                    {i18n.cancel}
                </Button>
                <Button onClick={() => onValidate(sampling) } variant='contained' color='primary'>
                    {i18n.save}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

SamplingModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onValidate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onReject: PropTypes.func,
    selectedSampling: PropTypes.instanceOf(DtoSampling).isRequired,
}

export default SamplingModal
